import axios, { type AxiosInstance } from 'axios';
import { useAuthStore } from '../stores/auth.store';
import { toast } from '../stores/toast.store';

const baseURL = import.meta.env.VITE_API_URL ?? '/api';

export const api: AxiosInstance = axios.create({ baseURL, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status: number | undefined = err.response?.status;
    const serverMsg: string =
      err.response?.data?.error ??
      err.response?.data?.message ??
      err.message;
    if (status === 401) {
      useAuthStore.getState().logout();
    } else if (status === 403) {
      toast.error('Недостаточно прав');
    } else if (status && status >= 500) {
      toast.error(`Серверная ошибка: ${serverMsg}`);
    } else if (status && status >= 400 && serverMsg) {
      toast.error(serverMsg);
    } else if (!err.response) {
      toast.error('Нет связи с сервером');
    }
    return Promise.reject(err);
  }
);
